import React, {useEffect} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Input from "../../../ui/components/Input/Input";
import {useTranslation} from "react-i18next";
import cl from './UserForm.module.css';
import UserFormRequestsGrid from "./components/UserFormRequestsGrid";
import UserFormAccountsGrid from "./components/UserFormAccountsGrid";
import {DateTimePickerComponent, Inject, MaskedDateTime} from "@syncfusion/ej2-react-calendars";
import CamerasGrid from "./components/CamerasGrid";
import {useFormik} from "formik";
import moment from "moment/moment";
import * as Yup from "yup";

const UserForm = ({unetPhones, name, surname,middleName, birthdate,isBlocked,userSetting, isAllowVote,cameras, accountRequests,accounts, crmId,email,
                      phone,  isAllowCheckLists,   onSubmit, ...rest}) => {
    const {t} = useTranslation();

    const form = useFormik({
        //enableReinitialize: true,
        initialValues: {
            unetPhones: unetPhones,

        },
        onSubmit: onSubmit
    });

    useEffect(() => {
        form.setFieldValue('unetPhones', unetPhones)
    }, [unetPhones]);


    return (
        <Container fluid>
            <form id='post-form' onSubmit={form.handleSubmit}>
            <Row>
                <Col>
                    <div className='input-container'>
                        <label className='label'>
                            {t("user.form.name")}
                        </label>
                        <Input name='name'
                               type='text'
                               placeholder={t("user.form.name")}
                               disabled={true}
                               autoComplete='off'
                               value={name}/>
                    </div>

                    <div className='input-container'>
                        <label className='label'>
                            {t("user.form.surname")}
                        </label>
                        <Input name='surname'
                               type='text'
                               placeholder={t("user.form.surname")}
                               disabled={true}
                               autoComplete='off'
                               value={surname}/>
                    </div>

                    <Row>
                        <Col>
                            <div className='input-container'>
                                <label className='label'>
                                    {t("user.form.middle-name")}
                                </label>
                                <Input name='middleName'
                                       type='text'
                                       placeholder={t("user.form.middle-name")}
                                       disabled={true}
                                       autoComplete='off'
                                       value={middleName}/>
                            </div>
                        </Col>
                        <Col>
                            <div className='input-container syncfusion-control-input-container'>
                                <label className='label'>
                                    {t("user.form.birthday")}
                                </label>
                                <DateTimePickerComponent placeholder={t("user.form.birthday")}
                                                         enabled={false}
                                                         value={birthdate}
                                                         enableMask={true}
                                                         format='dd.MM.yyyy'
                                                         maskPlaceholder={{
                                                             day: 'dd',
                                                             month: 'MM',
                                                             year: 'yyyy'
                                                         }}>
                                    <Inject services={[MaskedDateTime]}/>
                                </DateTimePickerComponent>
                            </div>
                        </Col>
                    </Row>

                    <div className='input-container checkbox'>
                        <Input name='isBlocked'
                               type='checkbox'
                               disabled={true}
                               checked={isBlocked}/>
                        <label className='label'>
                            {t("user.form.blocked")}
                        </label>
                    </div>
                    {userSetting &&
                        <>
                            <div className='input-container checkbox'>
                                <Input name='showAllIncidents'
                                       type='checkbox'
                                       disabled={true}
                                       checked={!userSetting.showAllIncidents}/>
                                <label className='label'>
                                    {t("user.form.show-my-incidents")}
                                </label>
                            </div>

                            <div className='input-container checkbox'>
                                <Input name='stopNewsNotification'
                                       type='checkbox'
                                       disabled={true}
                                       checked={!userSetting.stopNewsNotification}/>
                                <label className='label'>
                                    {t("user.form.receive-news-notifications")}
                                </label>
                            </div>
                        </>
                    }
                    <div className='input-container checkbox'>
                        <Input name='isAllowVote'
                               type='checkbox'
                               disabled={true}
                               checked={isAllowVote}/>
                        <label className='label'>
                            {t("user.form.is-allow-vote")}
                        </label>
                    </div>

                    <div className='input-container checkbox'>
                        <Input name='isAllowCheckLists'
                               type='checkbox'
                               disabled={true}
                               checked={isAllowCheckLists}/>
                        <label className='label'>
                            {t("user.form.is-allow-check-lists")}
                        </label>
                    </div>
                </Col>
                <Col>
                    <div className='input-container'>
                        <label className='label'>
                            {t("user.form.phone")}
                        </label>
                        <Input name='phone'
                               type='text'
                               placeholder={t("user.form.phone")}
                               disabled={true}
                               autoComplete='off'
                               value={phone}/>
                    </div>
                    <div className='input-container'>
                        <label className='label'>
                            {t("user.form.unetPhones")}
                        </label>
                        <Input name='unetPhones'
                               type='text'
                               onChange={form.handleChange}
                               placeholder={t("user.form.unetPhones")}
                               disabled={form.isSubmitting}
                               autoComplete='off'
                               value={form.values.unetPhones}/>
                    </div>
                    <div className='input-container'>
                        <label className='label'>
                            {t("user.form.email")}
                        </label>
                        <Input name='email'
                               type='text'
                               placeholder={t("user.form.email")}
                               disabled={true}
                               autoComplete='off'
                               value={email}/>
                    </div>

                    <div className='input-container'>
                        <label className='label'>
                            {t("user.form.crm-id")}
                        </label>
                        <Input name='crmId'
                               type='text'
                               placeholder={t("user.form.crm-id")}
                               disabled={true}
                               autoComplete='off'
                               value={crmId}/>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col style={{margin: '10px 0'}}>
                    <div className={cl.header}>
                        {t("user.form.accounts-label")}
                    </div>
                    <UserFormAccountsGrid accounts={accounts} {...rest}/>
                </Col>
            </Row>
            <Row>
                <Col style={{margin: '10px 0'}}>
                    <div className={cl.header}>
                        {t("user.form.account-request-label")}
                    </div>
                    <UserFormRequestsGrid requests={accountRequests}/>
                </Col>
            </Row>
            <Row>
                <Col style={{margin: '10px 0'}}>
                    <div className={cl.header}>
                        {t("user.form.cameras")}
                    </div>
                    <CamerasGrid requests={cameras}/>
                </Col>
            </Row>
            </form>
        </Container>
    );
};

export default UserForm;
